import React, { useEffect, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';
import { LibraryErrorState, LibraryLoading } from '@/components/forms/LibraryStates';
import { columnLabel, formatCell, registerError } from '@/lib/auditRegisters';

export default function AuditRegisterPrintPage() {
  const { registerType } = useParams(); const [sp] = useSearchParams();
  const [payload, setPayload] = useState(null); const [error, setError] = useState(null);
  useEffect(() => {
    const q = new URLSearchParams(sp); q.delete('page'); q.delete('pageSize');
    api.get(`/audit/registers/${registerType}/print?${q}`).then(({ data }) => setPayload(data.data)).catch((e) => setError(registerError(e)));
  }, [registerType, sp]);
  if (error) return <div className="p-6"><LibraryErrorState error={error} /></div>;
  if (!payload) return <LibraryLoading label="Preparing print view…" />;
  const filters = Object.entries(payload.filters || {});
  return (
    <div className="max-w-6xl mx-auto p-6 print:p-0 text-sm" data-testid="register-print-page">
      <div className="flex justify-between items-center mb-4 print:hidden">
        <Link to={`/audit/registers/${registerType}`} className="underline" data-testid="register-print-back">← Back to register</Link>
        <Button onClick={() => window.print()} data-testid="register-print-btn">Print</Button>
      </div>
      <header className="border-b pb-3 mb-4">
        <p className="text-xs uppercase tracking-wide text-muted-foreground">{payload.organisation_name} · NDIS Audit Readiness Centre</p>
        <h1 className="text-xl font-semibold" data-testid="register-print-title">{payload.title}</h1>
        <p className="text-xs text-muted-foreground">Generated {formatCell(payload.generated_at)} UTC · {payload.total} entr{payload.total === 1 ? 'y' : 'ies'}{filters.length ? ` · Filters: ${filters.map(([k, v]) => `${columnLabel(k)} = ${v}`).join('; ')}` : ''}</p>
        {payload.disclosure && <p role="note" className="text-xs mt-2 border p-2" data-testid="register-print-disclosure">{payload.disclosure}</p>}
      </header>
      <table className="w-full border-collapse text-xs" data-testid="register-print-table">
        <caption className="sr-only">{payload.title}</caption>
        <thead><tr>{payload.columns.map((c) => <th key={c} scope="col" className="border px-2 py-1 text-left bg-muted/40">{columnLabel(c)}</th>)}</tr></thead>
        <tbody>
          {payload.rows.length === 0 ? <tr><td colSpan={payload.columns.length} className="border px-2 py-4 text-center text-muted-foreground">No entries</td></tr>
            : payload.rows.map((r, i) => <tr key={r.id || i} className="break-inside-avoid">{payload.columns.map((c) => <td key={c} className="border px-2 py-1 align-top">{formatCell(r[c])}</td>)}</tr>)}
        </tbody>
      </table>
      <footer className="mt-4 text-xs text-muted-foreground">Working record for audit preparation only — not a statement of certification, compliance or audit outcome.</footer>
    </div>
  );
}
